import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import styled from '@emotion/styled';
import { ZIndex } from 'constants/zIndex';
import { OutlineHeartIcon } from 'icons/OutlineHeartIcon';
import { ProfileImage } from 'app-components/accounts/profiles/ProfileImage';
import React from 'react';

export const LikedByProfile = ({
  className,
  profile,
  size = 16,
}: {
  className?: string;
  profile: ProfileLitePublicRelayDto;
  size?: number;
}) => (
  <StyledWrapper className={className}>
    <ProfileImage file={profile.profileImage} defaultImageKey={profile.nickname} size={size} />
    <StyledIconWrapper>
      <OutlineHeartIcon />
    </StyledIconWrapper>
  </StyledWrapper>
);

const StyledWrapper = styled.div`
  width: 20px;
  height: 18px;
  position: relative;
`;

const StyledIconWrapper = styled.div`
  display: flex;
  position: absolute;
  bottom: -1px;
  right: -1px;
  z-index: ${ZIndex.ReplyLikedByProfileIcon};
`;
